import { IKnmSubjectType } from 'APIPackage/CatalogsModule/interfaces/IKnmSubjectType';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiGet, apiPost, apiPut } from 'APIPackage/MainModule/common/apiTools';

export async function fetchKnmSubjectTypesAll(): Promise<IKnmSubjectType[]> {
  return apiGet<IKnmSubjectType[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-subject-types/all`);
}

export async function createKnmSubjectType(knmForm: Omit<IKnmSubjectType, 'id'>): Promise<void> {
  return apiPost<void>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-subject-types`,
    body: knmForm,
  });
}

export async function updateKnmSubjectType(knmForm: IKnmSubjectType): Promise<void> {
  const { id, ...data } = knmForm;

  return apiPut<void>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-subject-types/${id}`, data);
}
